import { render } from "./Index.vue?vue&type=template&id=880d78d8&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=880d78d8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-880d78d8"

export default script